import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography, useMediaQuery } from "@material-ui/core";
import {
  DirectionsBus as Bus,
  Restaurant as Utensils,
  ChildFriendly as BabyCarriage,
  CardGiftcard,
  DirectionsRun as Running,
  ThumbUpAlt as Like,
  School as Education,
} from "@material-ui/icons";
import { v4 } from "uuid";
import { VictoryPie } from "victory";
import { ReactComponent as UserMd } from "../../../assets/icons/health-insurance-benefit-icon-active.svg";
import useStyles from "./styles";
import IconLabel from "./components/IconLabel";
import { getIconColor } from "./components/IconLabel/styles";
import { MonetaryAmount } from "../../domain/monetary-amount";
import { translate as t } from "../../../infrastructure/translate/localization";

const getIcon = ({ name, ...rest }) => {
  switch (name) {
    case "health-insurance":
      return <UserMd {...rest} />;
    case "meal":
      return <Utensils {...rest} />;
    case "nursery":
      return <BabyCarriage {...rest} />;
    case "gyms":
      return <Running {...rest} />;
    case "transport":
      return <Bus {...rest} />;
    case "gift-card":
      return <CardGiftcard {...rest} />;
    case "education":
      return <Education {...rest} />;
    default:
      return <Like {...rest} />;
  }
};

export default function PieChartBlock({ data, currency }) {
  const isXL = useMediaQuery("(min-width: 1900px)");
  const { container, bolder, legendContainer } = useStyles({ isXL });
  return (
    <Grid item container xs={12} className={container}>
      <Grid
        item
        container
        xs={4}
        xl={3}
        direction="column"
        alignItems="flex-start"
      >
        {data?.map(({ name, amountInCents }, i) => (
          <Grid
            key={v4()}
            item
            container
            className={legendContainer}
            alignItems="center"
          >
            <Grid item container xs={3} alignItems="center" justify="center">
              {{
                ...getIcon({ name: name.replace("-benefit", "") }),
                props: { color: getIconColor(i) },
              }}
            </Grid>
            <Grid item container xs={9} alignItems="flex-end">
              <Grid item xs={12}>
                <Typography variant="body2">
                  {t(
                    `benefits-section.${name}.${name.replace("-benefit", "")}`
                  )}
                </Typography>
              </Grid>
              <Grid item xs={12} container alignItems="flex-start">
                <Typography variant="body2" className={bolder}>
                  {currency
                    ? MonetaryAmount.ofCurrency({
                        amountInCents,
                        currency,
                      }).prettifyMoney({})
                    : amountInCents}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
      <Grid item container xs={8} xl={9} alignItems="center" justify="center">
        <VictoryPie
          data={data?.map(({ amountInCents }, i) => ({
            x: i + 1,
            y: amountInCents,
            label: "",
          }))}
          colorScale={data?.map((item, i) => getIconColor(i))}
          innerRadius={80}
          labelComponent={
            <IconLabel
              icons={data?.map(({ name }) =>
                getIcon({ name: name.replace("-benefit", "") })
              )}
              style={[{ fill: "transparent", fontSize: 25 }]}
            />
          }
        />
      </Grid>
    </Grid>
  );
}
PieChartBlock.defaultProps = {
  data: [],
  currency: undefined,
};
PieChartBlock.propTypes = {
  data: PropTypes.array,
  currency: PropTypes.string,
};
